
import Vue from 'vue'
import JcdcListBox from '@/components/jcdc/JcdcListBox.vue'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'
import { VCol, VRow, VSkeletonLoader } from 'vuetify/lib'

interface listItems {
  active: string
  title: string
}

export default Vue.extend({
  name: 'JcdcDualListBox',
  components: {
    JcdcListBox,
    JcdcBtn,
    VRow,
    VCol,
    VSkeletonLoader,
  },
  props: {
    // Lists pre user actions
    itemList: { type: Array as () => Array<listItems>, default: (): [] => [] },
    moveAll: { type: Boolean, default: false },
    saveBtn: { type: Boolean, default: false },
    inactiveTitle: { type: String, default: '' },
    activeTitle: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    unsaved: { type: Boolean, default: false },
  },
  data() {
    return {
      edited: false, // Lists mid user actions
      chosenItemList: [],
      chosenActiveList: [], // Lists post user actions
      inactiveList: this.itemList
        .filter((s) => s.active == 'N')
        .map((e) => {
          return e.title
        }),
      activeList: this.itemList
        .filter((s) => s.active == 'Y')
        .map((e) => {
          return e.title
        }),
      savedActiveList: this.itemList
        .filter((s) => s.active == 'Y')
        .map((e) => {
          return e.title
        }),
    }
  },
  computed: {
    newList(): Array<listItems> {
      const fullList = this.itemList
      fullList.forEach((listItem) => {
        const active = this.activeList.find((title) => title == listItem.title)
        if (active) listItem.active = 'Y'
        else listItem.active = 'N'
      })
      return fullList
    },
  },
  methods: {
    moveAllItems(direction) {
      if (direction === 'right') {
        this.activeList = [...this.activeList, ...this.inactiveList]
        this.inactiveList = []
      } else {
        this.inactiveList = [...this.activeList, ...this.inactiveList]
        this.activeList = []
      }
      this.emitChange()
    },
    moveItems(chosenList, fromList, toList) {
      for (let i = chosenList.length - 1; i >= 0; i--) {
        const index = fromList.indexOf(chosenList[i])
        fromList.splice(index, 1)
        toList.push(chosenList[i])
      }
      this.emitChange()
    },
    emitChange() {
      this.edited = true
      // Reset chosen lists
      this.chosenItemList.length = 0
      this.chosenActiveList.length = 0
      // Check if selections have changed
      const equal =
        JSON.stringify(this.savedActiveList.sort()) ==
        JSON.stringify(this.activeList.sort())
      // Emit change
      if (equal) this.$emit('change', false)
      else this.$emit('change', this.newList)
    },
    emitSave() {
      // Update Saved Active list
      this.$emit('save', this.newList)
      this.savedActiveList = this.activeList
      this.edited = false
    },
  },
})
